@let getVendorByIdState = store.getVendorByIdState();

<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/main" />
    </ion-buttons>
    <ion-title>{{ "VENDORS.EDIT_VENDOR" | translate }}</ion-title>
    <ion-buttons slot="end">
      <mtjr-submit-button
        fill="clear"
        color="danger"
        [label]="'COMMON.DELETE' | translate"
        type="button"
        data-cy="vendor-delete-button"
        (click)="deleteVendor()"
        [state]="editStore.vendorDeleteState()"
      />
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="flex flex-col max-w-[600px] px-5 pt-6 mx-auto">
    @switch (getVendorByIdState.type) {
      @case ("loading") {
        <mtjr-loading />
      }
      @case ("error") {
        <mtjr-error [failure]="getVendorByIdState.failure" />
      }
      @case ("success") {
        <form [formGroup]="updateUtils.form" (ngSubmit)="submit()">
          <div class="mb-2 w-full px-4 py-1"></div>
          <fieldset [disabled]="updateUtils.form.disabled">
            <div class="flex flex-col items-center justify-center gap-8">
              <div class="mt-4 mb-4 size-44 aspect-square">
                <mtjr-attachment-field
                  [singleMode]="true"
                  [field]="form.controls.logo"
                  borderRadiusClass="rounded-full"
                  labelTr="VENDORS.LOGO_IMAGE"
                />
              </div>
            </div>

            <div class="aspect-[2/0.75] my-4">
              <mtjr-attachment-field
                [singleMode]="true"
                [field]="form.controls.background"
                [labelTr]="'VENDORS.BACKGROUND_IMAGE'"
                borderRadiusClass="rounded-xl"
              />
            </div>
            <div class="my-8"></div>
            <mtjr-text-field
              data-cy="vendor-name-input"
              [field]="updateUtils.form.controls.name"
              [label]="'VENDORS.NAME' | translate"
              class="w-full"
            />

            <div class="my-4"></div>
            @let addressStreet = updateUtils.form.controls.addressStreet.value;
            <ion-card class="border-none !m-0 rounded-md">
              <ion-item lines="none">
                <ion-text class="font-bold">{{ "VENDORS.ADDRESS" | translate }}</ion-text>
                <ion-button
                  slot="end"
                  fill="clear"
                  color="primary"
                  [routerLink]="['/main/account/addresses']"
                  [queryParams]="{ pickerMode: true, redirect: `/main/vendors/${this.vendorId}/edit` }"
                >
                  <ion-text class="text-[1rem]">
                    {{ (addressStreet ? "COMMON.CHANGE" : "COMMON.ADD") | translate }}
                  </ion-text>
                </ion-button>
              </ion-item>
              @if (addressStreet) {
                <div class="bg-light ms-4 h-[1px]"></div>
                <ion-item lines="none">
                  <ion-text>
                    {{ updateUtils.form.controls.addressLabel.value }}
                    <span class="text-medium ms-1">{{ addressStreet }}</span>
                  </ion-text>
                </ion-item>
              }
            </ion-card>
          </fieldset>
          <div class="my-2">
            <mtjr-error-bar [failure]="editStore.vendorUpdateFailure()" />
          </div>
          <div class="mb-2 mt-4 flex justify-end">
            <mtjr-back-button [label]="'COMMON.CANCEL' | translate" />
            <mtjr-submit-button
              data-cy="vendor-update-button"
              [label]="'COMMON.SAVE' | translate"
              [state]="editStore.vendorUpdateState()"
            />
          </div>
        </form>
      }
    }
  </div>
</ion-content>
